export default {
  namespaced: true,
  state: {
    user: null
  },
  getters: {
    user(state) {
      return state.user;
    }
  },
  mutations: {
    clearUser(state) {
      state.user = null;
    },
    setUser(state, user) {
      state.user = user;
    }
  }
};
